import { apiClient } from "../../../config/axios.config";
import type { ListResponse, PaginationResponse, Response } from "../../../types/api.types";
import type { dpsActiveObject, getQuotationListForm, newQuotationForm, QuotationCopyForm } from "../dtos/request/quotation.request";
import type { ListQuotationItem, RecentQuotationItem } from "../dtos/response/quotation.response";
import type { CopyStoreResponse } from "../dtos/response/store.response";

const model = "/v1/quotation";

export const getQuotationList = async (query: getQuotationListForm): Promise<PaginationResponse<ListQuotationItem>> => {
  const { data } = await apiClient.get(model, { params: query });
  return data;
};

export const getQuotationDefault = async (storeId?: string | number): Promise<Response<RecentQuotationItem | newQuotationForm>> => {
  const { data } = await apiClient.get(`${model}/default`, { params: { storeId } });
  return data;
};

export const getQuotationDetail = async (id: string) => {
  const { data } = await apiClient.get(`${model}/${id}`);
  return data;
};

export const getQuotationRecent = async (id: string): Promise<Response<RecentQuotationItem | newQuotationForm>> => {
  const { data } = await apiClient.get(`${model}/recent?storeId=${id}`);

  return data;
};

export const postQuotation = async (form: newQuotationForm) => {
  const { data } = await apiClient.post(model, form);
  return data;
};

export const getQuotationCopyList = async (form: QuotationCopyForm): Promise<ListResponse<CopyStoreResponse[]>> => {
  const { data } = await apiClient.get(`${model}/copy`, {
    params: form
  });
  return data;
}

export const postDpActive = async (form: dpsActiveObject) => {
  const { data } = await apiClient.post(`${model}/dp/active`, {}, {
    params: form
  });
  return data;
}